import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Container, Row, Col, Label, Input, Spinner, Button, Alert } from "reactstrap"
import { useLocation, useParams } from "react-router-dom"
import Breadcrumbs from "../components/Common/Breadcrumb"
import withRouter from "components/Common/withRouter"
import { useDispatch, useSelector } from "react-redux"
import {
  createUser,
  updateUser,
  getUsersData,
  clearErrors,
  deleteUser,
  getUser,
} from "../store/actions"
import { sendAdminPasswordResetLink } from "../helpers/backend-helper"

const Dashboard = props => {
  const params = useParams()
  const userId = params?.id
  const dispatch = useDispatch()
  const {
    updateUserLoading,
    createUserLoading,
    deleteUserLoading,
    message,
    selectedUser,
    getUserLoading,
  } = useSelector(state => state.Dashboard)

  const themeColor = useSelector(state => state.theme.color)
  const { user: loggedUser } = useSelector(state => state.Login)
  const canManageUserTypes = [1, 2].includes(Number(loggedUser?.role))

  useEffect(() => {
    document.documentElement.style.setProperty("--scrollbar-color", themeColor)
  }, [themeColor])
  const User = selectedUser?.user

  const [firstName, setFirstName] = useState("")
  const [lastName, setLastName] = useState("")
  const [email, setEmail] = useState("")
  const [password, setPassword] = useState("")
  const [userType, setUserType] = useState("portal")
  const [resetLinkLoading, setResetLinkLoading] = useState(false)

  const onEmailPasswordReset = async () => {
    if (!userId || !email) return
    const ok = window.confirm(`Send reset email to ${email}?`)
    if (!ok) return
    try {
      setResetLinkLoading(true)
      await sendAdminPasswordResetLink(userId)
      alert("Password reset email sent")
    } catch (err) {
      const msg =
        err?.response?.data?.message ||
        err?.message ||
        "Failed to send password reset email"
      alert(msg)
    } finally {
      setResetLinkLoading(false)
    }
  }

  const onSubmit = () => {
    if (!email) return alert("User email is required")
    if (!userId && !password) return alert("User password is required")
    const strongPass = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

    if (!strongPass.test(password)) {
      return alert(
        "Password must be at least 8 characters and contain at least 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character."
      );
    }
    let emailReg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
    if (!emailReg.test(email)) return alert("Please enter valid email")

    const role =
      userType === "admin" ? 2 : userType === "distributor" ? 4 : 3

    const payload = {
      firstName,
      lastName,
      ...(userId ? {} : { email }),
      ...(password ? { password } : {}),
      role,
    }

    dispatch(
      userId
        ? updateUser(payload, props.router.navigate, getUsersData, undefined, userId)
        : createUser(payload, props.router.navigate, getUsersData)
    )
  }

  useEffect(() => {
    setTimeout(() => {
      dispatch(clearErrors())
    }, 8000)
  }, [message])

  useEffect(() => {
    if (userId) {
      dispatch(getUser(userId))
    }
  }, [userId, dispatch])

  useEffect(() => {
    if (userId && User) {
      setFirstName(User.firstName)
      setLastName(User.lastName)
      setEmail(User.email)
      if (Number(User?.role) === 2) setUserType("admin")
      else if (Number(User?.role) === 4) setUserType("distributor")
      else setUserType("portal")
    } else if (!userId) {
      setUserType("portal")
    }
  }, [User, userId])

  //meta title
  document.title = `${userId ? "Update" : "Create"} User - ColdBlock Technologies Inc.`

  return (
    <React.Fragment>
      <div className="page-content white-bg">
        <div className="row-spaceBtwn align-items-center mb-4">
          <div className="h2 mb-0 heading">{!userId ? "Add" : "Update"} User</div>
        </div>
        {!!message && <Alert color="danger" className="mb-4">{String(message)}</Alert>}
        {!getUserLoading ? <Container fluid>
          {/* Render Breadcrumb */}
          {/* <Breadcrumbs
            title="Dashboard"
            breadcrumbItem={userId ? "Update User" : "Add User"}
          /> */}
          <Row>
            <Col md={6}>
              <div className="mb-3">
                <Label className="form-label">First name</Label>
                <Input
                  name="firstName"
                  type="text"
                  placeholder="John"
                  value={firstName}
                  onChange={e => setFirstName(e.target.value)}
                />

              </div>
            </Col>
            <Col md={6}>
              <div className="mb-3">
                <Label className="form-label">Last name</Label>
                <Input
                  name="lastName"
                  type="text"
                  placeholder="Doe"
                  value={lastName}
                  onChange={e => setLastName(e.target.value)}
                />

              </div>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <label htmlFor="example-search-input" className="col-form-label">
                Email:
              </label>
              <input
                className="form-control"
                type="text"
                disabled={!!userId}
                placeholder="Please enter email"
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
            </Col>
            <Col lg={6}>
              <label htmlFor="example-search-input" className="col-form-label">
                Password:
              </label>
              <input
                className="form-control"
                type="text"
                placeholder="Please enter password"
                value={password}
                onChange={e => setPassword(e.target.value)}
              />
            </Col>
          </Row>
          {canManageUserTypes && (
            <Row className="mt-2">
              <Col lg={6}>
                <Label className="form-label">User type</Label>
                <Input
                  type="select"
                  value={userType}
                  onChange={(e) => setUserType(e.target.value)}
                >
                  <option value="portal">Portal user</option>
                  <option value="admin">Admin</option>
                  <option value="distributor">Distributor</option>
                </Input>
              </Col>
            </Row>
          )}
          {/* {!!message && <p className="error-message">{message}</p>} */}
          <div className="action-btn-container">
            <Button
              color="secondary"
              disabled={updateUserLoading || createUserLoading || deleteUserLoading || resetLinkLoading}
              onClick={() => props.router.navigate('/users')}
            >
              Cancel
            </Button>
            {!!userId &&
              <button
                className="add-new-user decline"
                disabled={updateUserLoading || createUserLoading || deleteUserLoading || resetLinkLoading}
                onClick={() =>
                  dispatch(
                    deleteUser(
                      props.router.navigate,
                      getUsersData,
                      userId
                    )
                  )
                }
              >
                {deleteUserLoading ? "Deleting User..." : "Delete"}
              </button>
            }
            {!!userId && (
              <button
                type="button"
                className="add-new-user"
                style={{ backgroundColor: "#0d6efd" }}
                disabled={
                  updateUserLoading ||
                  createUserLoading ||
                  deleteUserLoading ||
                  resetLinkLoading
                }
                onClick={onEmailPasswordReset}
              >
                {resetLinkLoading ? (
                  <>
                    <Spinner size="sm" className="me-2" />
                    Sending...
                  </>
                ) : (
                  "Email Password Reset"
                )}
              </button>
            )}
            <button
              className="add-new-user"
              onClick={onSubmit}
              disabled={updateUserLoading || createUserLoading || deleteUserLoading || resetLinkLoading}
            >
              {!!updateUserLoading ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Updating User...
                </>
              ) : !!createUserLoading ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  Adding User...
                </>
              ) : userId ? (
                "Update"
              ) : (
                "Add"
              )}
            </button>
          </div>
        </Container> :
          <div
            className="loading-container"
            style={{
              width: "100%",
              height: "60dvh",
              display: "grid",
              placeItems: "center",
            }}
          >
            <Spinner />
          </div>}
      </div>
    </React.Fragment>
  )
}

Dashboard.propTypes = {
  t: PropTypes.any,
  chartsData: PropTypes.any,
  onGetChartsData: PropTypes.func,
  history: PropTypes.object,
}

export default withRouter(Dashboard)
